import {
    SET_SELECTED_COST_CENTER,
    SET_SELECTED_ORDER_TYPE,
    GET_VEHICLE_TYPE,
    SET_VEHICLE_TYPE,
    GET_MAKE_LIST,
    SET_MAKE_LIST,
    GET_VEHICLE_SPEC_LIST,
    SET_VEHICLE_SPEC_LIST,
    SET_ORDER_DATA,
    SET_ORDER_CART_DATA,
    GET_MANAGED_EQUIPEMENT_TYPES,
    SET_MANAGED_EQUIPEMENT_TYPES,
    GET_CATALOG_ITEMS,
    SET_CATALOG_ITEMS,
    UPLOAD_BULK_ORDER_ATTACHMENTS,
    SET_BULK_ORDER_ATTACHMENTS,
    REMOVE_BULK_ORDER_ATTACHMENT,
    SHOW_MY_CART_ALERT,
    GET_BULK_ORDER_MANAGED_EQUIPMENT_DROP_DOWN,
    SET_BULK_ORDER_MANAGED_EQUIPMENT_DROP_DOWN,
    SET_BULK_ORDER_FLEET_ATTACHMENTS,
    GET_BULK_ORDER_FLEET_ATTACHMENTS,
    SET_IS_APPROVAL_OVERRIDE
} from "./BulkOrderType"

const setSelectedCostCenter = (costcenter: any) => ({
    type: SET_SELECTED_COST_CENTER,
    costcenter
});

const setSelectedOrderType = (orderType: any) => ({
    type: SET_SELECTED_ORDER_TYPE,
    orderType
});

const setIsApprovalOverride = (isApprovalOverride: any) => ({
    type: SET_IS_APPROVAL_OVERRIDE,
    isApprovalOverride
});

const getVehicleType = (assetSubTypeId: number) => ({
    type: GET_VEHICLE_TYPE,
    assetSubTypeId
});

const setVehicleType = (vehicleType: any) => ({
    type: SET_VEHICLE_TYPE,
    vehicleType
});

const getMakeList = (orderRequestSubTypeId: number, requestIndex: number) => ({
    type: GET_MAKE_LIST,
    orderRequestSubTypeId,
    requestIndex
});

const setMakeList = (makeList: any) => ({
    type: SET_MAKE_LIST,
    makeList
});

const getVehicleSpecList = (make: string, orderRequestSubTypeId: number, requestIndex: number) => ({
    type: GET_VEHICLE_SPEC_LIST,
    make,
    orderRequestSubTypeId,
    requestIndex
});

const setVehicleSpecList = (vehicleSpecList: any) => ({
    type: SET_VEHICLE_SPEC_LIST,
    vehicleSpecList
});

const setOrderData = (data: any) => ({
    type: SET_ORDER_DATA,
    data
});

const setOrderCartData = (cartData: any) => ({
    type: SET_ORDER_CART_DATA,
    cartData
});

const getManagedEquipementTypes = (assetSubTypeId: number) => ({
    type: GET_MANAGED_EQUIPEMENT_TYPES,
    assetSubTypeId
});

const setManagedEquipementTypes = (managedEquipementsList: any) => ({
    type: SET_MANAGED_EQUIPEMENT_TYPES,
    managedEquipementsList
})

const getCatalogItems = (payload: any, requestIndex: number) => ({
    type: GET_CATALOG_ITEMS,
    payload,
    requestIndex
});

const setCatalogItems = (catalogItems: any) => ({
    type: SET_CATALOG_ITEMS,
    catalogItems
});

const uploadBulkOrderAttachments = (attachmentList: any, requestIndex: number) => ({
    type: UPLOAD_BULK_ORDER_ATTACHMENTS,
    attachmentList,
    requestIndex
});

const setBulkOrderAttachments = (attachmentList: any, requestIndex: number) => ({
    type: SET_BULK_ORDER_ATTACHMENTS,
    attachmentList,
    requestIndex
});

const removeBulkOrderAttachment = (attachmentList: any, requestIndex: number) => ({
    type: REMOVE_BULK_ORDER_ATTACHMENT,
    attachmentList,
    requestIndex
})

const showMyCartAlert = (isSucessfull: boolean, label: string) => ({
    type: SHOW_MY_CART_ALERT,
    isSucessfull,
    label
})

const getBulkOrderManagedEquipmentDropDown = (subTypeId: number, requestIndex:any) => {
    return ({
        type: GET_BULK_ORDER_MANAGED_EQUIPMENT_DROP_DOWN,
        assetSubTypeId: subTypeId,
        requestIndex
    })
};

const setBulkOrderManagedEquipmentDropDown = (managedEquipmentDropDown: any) => ({
    type: SET_BULK_ORDER_MANAGED_EQUIPMENT_DROP_DOWN,
    managedEquipmentDropDown: managedEquipmentDropDown,
});

const getBulkOrderFleetAttachments = (attachmentList: any) => ({
    type: GET_BULK_ORDER_FLEET_ATTACHMENTS,
    attachmentList
});

const setBulkOrderFleetAttachments = (isAttachmentListUploaded: any) => ({
    type: SET_BULK_ORDER_FLEET_ATTACHMENTS,
    isAttachmentListUploaded
});

export {
    setSelectedCostCenter,
    setSelectedOrderType,
    setIsApprovalOverride,
    getVehicleType,
    setVehicleType,
    getMakeList,
    setMakeList,
    getVehicleSpecList,
    setVehicleSpecList,
    setOrderData,
    setOrderCartData,
    getManagedEquipementTypes,
    setManagedEquipementTypes,
    getCatalogItems,
    setCatalogItems,
    uploadBulkOrderAttachments,
    setBulkOrderAttachments,
    removeBulkOrderAttachment,
    showMyCartAlert,
    getBulkOrderManagedEquipmentDropDown,
    setBulkOrderManagedEquipmentDropDown,
    setBulkOrderFleetAttachments,
    getBulkOrderFleetAttachments
}